import { AxiosResponse } from 'axios'
import { Moment } from 'moment'

import ClientSDK from '../../../App/ClientSDK'

class Client {
    static getData = (from: Moment, to: Moment): Promise<any> =>
        ClientSDK.instance()
            .get('hr-time/data', {
                'starts-at': from.format('YYYY-MM-DD'),
                'ends-at': to.format('YYYY-MM-DD'),
            })
            .then((response: AxiosResponse): any => {
                return response.data
            })
}

export default Client
